export enum MessageTypes {
  success = 'success',
  warning = 'warning',
  error = 'error',
  info = 'info'
}

/**
 * Message to be displayed as toast.
 * @param type Message type.
 * @param message Message translation key (or text).
 * @param id unique message identifier.
 * @param literalMessage Flag: is message already translated or otherwise should be shown without translating attempt.
 */
export interface Message {
  id: string
  type: MessageTypes
  message: string
  literalMessage?: boolean
}

export interface MessagesState {
  messages: Message[]
}
